{
  "title": "Розпочніть шлях турботи про себе",
  "subtitle": "Оберіть зручний спосіб",
  "googleButton": "Зареєструватись через Google",
  "facebookButton": "Зареєструватись через Facebook",
  "emailButton": "Зареєструватись через електронну пошту",
  "signinLink": "Вже маєте акаунт? Увійти",
  "orSeparator": "Або"
}
